/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { scenarioItemBulkEditDependencyRequestSchema } from './scenarioItemBulkEditDependencyRequestSchema';

export const scenarioItemBulkEditRequestSchema = z.object({
  deadlineDateTime: z.iso.datetime().nullish(),
  get dependency() {
    return z.union([scenarioItemBulkEditDependencyRequestSchema, z.null()]).optional();
  },
  earliestStartDateTime: z.iso.datetime().nullish(),
  estimationId: z.int().nullish(),
  itemIds: z
    .array(z.int())
    .min(1)
    .max(2147483647)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    }),
  itemStatusId: z.int().nullish(),
  teamId: z.int().nullish(),
});
